"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.districtsOfState = exports.districtShape = exports.MAP_LOCATION_ATTRIBUTION = void 0;
const austria_districts_1 = require("./austria-districts");
/** Attribution of the school positions and the urban/rural flag. */
exports.MAP_LOCATION_ATTRIBUTION = "Schulstandort = Gemeindemitte aus der PLZ; Stadt/Land: Urban-Rural-Typologie. Quelle: STATISTIK AUSTRIA (Gemeindeliste, Stadt-Land-Typologien; bearbeitet)";
const DISTRICT_BY_CODE = new Map(austria_districts_1.AUSTRIA_DISTRICTS.map((d) => [d.code, d]));
const districtShape = (code) => code ? DISTRICT_BY_CODE.get(code) : undefined;
exports.districtShape = districtShape;
/** Bezirke of one Bundesland in paint order (large first). */
const districtsOfState = (state) => austria_districts_1.AUSTRIA_DISTRICTS.filter((d) => d.state === state);
exports.districtsOfState = districtsOfState;
